import React, { useState, useEffect, useCallback, useRef } from 'react';
import $ from 'jquery';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { GoogleLogin } from 'react-google-login';
import './SocialPage.css';
import instagramIcon from '../../images/socialIcons/Instagram.png';
import fbIcon from '../../images/socialIcons/facebook.png';
import ytIcon from '../../images/socialIcons/youtubeicon.jpg';
import rocketIcon from '../../images/socialIcons/rocket.png';

const LIMIT = 4;
const FB_CLIENT_ID   = '231425867421205';
const GOOGLE_CLIENT_ID = '242384257630-cutoeuml04eq6e80t2rpg83leu0vpm97.apps.googleusercontent.com';
const CUSTOM_SITES   = ['Youtube', 'Facebook', 'Instagram', 'Others'];

const hintForSite = {
  Youtube:   { href: 'https://www.youtube.com/my_live_events', label: 'YouTube Live Events' },
  Facebook:  { href: 'https://www.facebook.com/live/create',   label: 'Facebook Live' },
  Instagram: { href: 'https://www.instagram.com/',             label: 'Instagram' },
  Others:    { href: 'https://restream.io/channel',            label: 'Restream' },
};

// ─── Page row ─────────────────────────────────────────────────────────────────
function PageRow({ icon, name, checked, disabled, onChange }) {
  return (
    <div className="sp-page">
      <div className="sp-page-info">
        <div className="sp-thumb">
          {typeof icon === 'string' && (icon.startsWith('data') || icon.includes('/'))
            ? <img src={icon} alt="" />
            : <span>{icon}</span>}
        </div>
        <span className="sp-page-name">{name}</span>
      </div>
      <label className="rs-switch">
        <input
          type="checkbox"
          className="pageCheckbox"
          checked={checked}
          disabled={disabled && !checked}
          onChange={onChange}
        />
        <span className="rs-slider" />
      </label>
    </div>
  );
}

// ─── Account subcard ──────────────────────────────────────────────────────────
function AccountSubcard({ email, onLogout, children }) {
  return (
    <div className="sp-subcard">
      <div className="sp-account-header">
        <span className="sp-account-email">{email}</span>
        <button className="sp-btn" onClick={onLogout}>Log out</button>
      </div>
      <div className="sp-page-list">{children}</div>
    </div>
  );
}

// ─── Platform card ────────────────────────────────────────────────────────────
function PlatformCard({ title, onAdd, children }) {
  return (
    <div className="sp-card">
      <div className="sp-card-header">
        <h3>{title}</h3>
        <button className="sp-btn" onClick={onAdd}>Add Account</button>
      </div>
      {children}
    </div>
  );
}

// ─── SocialPage ───────────────────────────────────────────────────────────────
export default function SocialPage({ notifySuccess, notifyError, location, history }) {
  const [facebookAccounts, setFbAccounts]   = useState([]);
  const [youtubeAccounts,  setYtAccounts]   = useState([]);
  const [customAccounts,   setCustomAccounts] = useState([]);
  const [instaAccounts,    setInstaAccounts] = useState([]);
  const [limitData,        setLimitData]    = useState({ selectCheckBoxLimit: 5 });
  const [activeCount,      setActiveCount]  = useState(0);

  const [inviteEmail,  setInviteEmail]  = useState('');
  const [limitToast,   setLimitToast]   = useState(false);

  // Custom RTMP modal
  const [customModal,    setCustomModal]    = useState(false);
  const [customSite,     setCustomSite]     = useState('Youtube');
  const [customName,     setCustomName]     = useState('');
  const [customRtmp,     setCustomRtmp]     = useState('');
  const [customKey,      setCustomKey]      = useState('');
  const [customUser,     setCustomUser]     = useState('');
  const [customPass,     setCustomPass]     = useState('');
  const [broadcastType,  setBroadcastType]  = useState('normal');

  const toastTimer = useRef(null);

  const showLimitToast = () => {
    setLimitToast(true);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setLimitToast(false), 2500);
  };

  // ── API ──────────────────────────────────────────────────────────────────────
  const loadAll = useCallback(() => {
    $.ajax({
      method: 'GET', url: '/api/v1/social/media',
      success(res) {
        const fb = [], yt = [], custom = [], insta = [];
        (res.response || []).forEach(s => {
          if (s.type === 'FACEBOOK')  fb.push(s);
          if (s.type === 'YOUTUBE')   { delete s.fbPages; yt.push(s); }
          if (s.type === 'CUSTOM')    { delete s.fbPages; custom.push(s); }
          if (s.type === 'INSTAGRAM') { delete s.fbPages; insta.push(s); }
        });
        setFbAccounts(fb); setYtAccounts(yt);
        setCustomAccounts(custom); setInstaAccounts(insta);
      },
      error() {}
    });
  }, []);

  const loadLimits = useCallback(() => {
    $.ajax({
      method: 'GET', url: '/api/v1/channel/limit',
      success(res) { setLimitData(res.response); },
      error() {}
    });
  }, []);

  useEffect(() => {
    loadAll(); loadLimits();
    const params = new URLSearchParams(location.search);
    if (params.get('code')) history.push('/dashboard/social/platform');
  }, []);

  useEffect(() => {
    const all = [...facebookAccounts, ...youtubeAccounts, ...customAccounts, ...instaAccounts];
    const total = all.filter(a =>
      a.selected || (a.fbPages && a.fbPages.some && a.fbPages.some(p => p.status))
    ).length;
    setActiveCount(total);
  }, [facebookAccounts, youtubeAccounts, customAccounts, instaAccounts]);

  // ── Facebook ─────────────────────────────────────────────────────────────────
  const handleFbResponse = (response) => {
    if (!response.accessToken) return;
    $.ajax({
      method: 'GET',
      url: `https://graph.facebook.com/v20.0/me?fields=accounts&access_token=${response.accessToken}`,
      success(success) {
        const fbPages = (success.accounts ? success.accounts.data : []).map(p => ({
          access_token: p.access_token, id: p.id, name: p.name
        }));
        fbPages.push({ name: response.name, id: response.id, access_token: response.accessToken, type: 'Timeline' });
        $.ajax({
          method: 'POST', url: '/api/v1/social/media',
          data: JSON.stringify({ data: { email: response.email, name: response.name, type: 'FACEBOOK', fbPages, access_token: response.accessToken, timelineId: response.id } }),
          success(res) { notifySuccess(res.message); loadAll(); loadLimits(); },
          error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
        });
      },
      error() {}
    });
  };

  // ── Google / YouTube ──────────────────────────────────────────────────────────
  const handleGoogleLogin = (user) => {
    $.ajax({
      method: 'POST', url: '/api/v1/social/media',
      data: JSON.stringify({ type: 'YOUTUBE', code: user.code }),
      success(res) { notifySuccess(res.message); loadAll(); loadLimits(); },
      error(err)   { console.log(err); if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Instagram ─────────────────────────────────────────────────────────────────
  const openInstaLogin = () => {
    const w = 700, h = 500;
    const top  = window.top.outerHeight / 2 + window.top.screenY - h / 2;
    const left = window.top.outerWidth  / 2 + window.top.screenX - w / 2;
    const win  = window.open('/instagram/login', 'Instagram Login',
      `toolbar=no,location=no,width=${w},height=${h},top=${top},left=${left}`);
    if (win) win.onunload = () => { loadAll(); loadLimits(); };
  };

  // ── Logout ────────────────────────────────────────────────────────────────────
  const logout = (account) => {
    $.ajax({
      method: 'DELETE', url: '/api/v1/facebook/logout',
      data: JSON.stringify({ id: account._id, type: account.type }),
      success(res) { notifySuccess(res.message); loadAll(); loadLimits(); },
      error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Facebook page toggle ──────────────────────────────────────────────────────
  const toggleFbPage = (acc, page) => {
    const all     = document.querySelectorAll('.pageCheckbox');
    const checked = [...all].filter(c => c.checked).length;
    if (checked > limitData.selectCheckBoxLimit && !page.selected) { showLimitToast(); return; }
    const newStatus = !page.selected;
    page.email = acc.email;
    $.ajax({
      method: 'POST', url: '/api/v1/add/facebook',
      data: JSON.stringify({ _id: acc._id, ...page, status: newStatus }),
      success() { loadAll(); }, error() {}
    });
  };

  // ── Custom / YouTube / Instagram toggle ───────────────────────────────────────
  const toggleCustomPage = (item) => {
    const all     = document.querySelectorAll('.pageCheckbox');
    const checked = [...all].filter(c => c.checked).length;
    if (checked > limitData.selectCheckBoxLimit && !item.selected) { showLimitToast(); return; }
    item.selected = !item.selected;
    $.ajax({
      method: 'PUT', url: '/api/v1/select/customPage',
      data: JSON.stringify(item),
      success() { loadAll(); }, error() {}
    });
  };

  // ── Custom RTMP submit ────────────────────────────────────────────────────────
  const handleCustomSubmit = (e) => {
    e.preventDefault();
    if (!customName || !customRtmp || !customKey) { notifyError('Fill in all required fields'); return; }
    const data = { type: 'CUSTOM', customRtmp, customStreamKey: customKey, name: customName, platformType: customSite, custom_username: customUser, custom_password: customPass };
    if (customSite === 'Instagram') data.broadcastType = broadcastType;
    setCustomModal(false);
    $.ajax({
      method: 'POST', url: '/api/v1/social/media', data: JSON.stringify(data),
      success(res) { notifySuccess(res.message); loadAll(); },
      error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Invite ────────────────────────────────────────────────────────────────────
  const sendInvite = () => {
    if (!inviteEmail) return;
    $.ajax({
      method: 'POST', url: '/api/v1/send/invitation',
      data: JSON.stringify({ email: inviteEmail, host: `${window.location.protocol}//${window.location.hostname}` }),
      success(res) { notifySuccess(res.message); setInviteEmail(''); },
      error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  const limitReached = activeCount >= limitData.selectCheckBoxLimit;

  return (
    <div className="sp-container">

      {/* ── Header ── */}
      <h2 className="sp-title">Destinos de Transmissão</h2>
      <div className="sp-counter">{activeCount} de {limitData.selectCheckBoxLimit} destinos ativos</div>

      {/* ── Platform grid ── */}
      <div className="sp-grid">

        {/* YouTube */}
        <PlatformCard
          title="YouTube"
          onAdd={() => document.getElementById('ytBtn') && document.getElementById('ytBtn').click()}
        >
          <div style={{ display: 'none' }}>
            <GoogleLogin
              scope="https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly"                      
              clientId={GOOGLE_CLIENT_ID}
              onSuccess={handleGoogleLogin}
              onFailure={() => {}}
              discoveryDocs='https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'
              prompt='consent'
              responseType="code"
              accessType="offline"
              render={p => <button id="ytBtn" onClick={p.onClick} />}
            />
          </div>
          {youtubeAccounts.length === 0 && (
            <div className="sp-subcard sp-empty">No YouTube accounts connected.</div>
          )}
          {youtubeAccounts.map((acc, i) => (
            <AccountSubcard key={acc._id || i} email={acc.name || acc.email} onLogout={() => logout(acc)}>
              <PageRow
                icon={acc.profilePic}
                name={acc.name || 'YouTube Channel'}
                checked={!!acc.selected}
                disabled={limitReached}
                onChange={() => toggleCustomPage(acc)}
              />
            </AccountSubcard>
          ))}
        </PlatformCard>

        {/* Facebook */}
        <PlatformCard
          title="Facebook"
          onAdd={() => document.getElementById('fbBtn') && document.getElementById('fbBtn').click()}
        >
          <div style={{ display: 'none' }}>
            <FacebookLogin
              appId={FB_CLIENT_ID}
              fields="name,email,picture"
              scope="email, publish_video, public_profile, pages_read_engagement, pages_manage_posts, pages_show_list"
              callback={handleFbResponse}
              render={p => <button id="fbBtn" onClick={p.onClick} />}
            />
          </div>
          {facebookAccounts.length === 0 && (
            <div className="sp-subcard sp-empty">No Facebook accounts connected.</div>
          )}
          {facebookAccounts.map((acc, i) => (
            <AccountSubcard key={acc._id || i} email={acc.email || acc.name} onLogout={() => logout(acc)}>
              {(acc.fbPages || []).map((page, j) => (
                <PageRow
                  key={page.id || j}
                  icon={page.profilePic}
                  name={page.type === "Timeline" ? "Timeline - "+page.name : page.name}
                  checked={!!page.selected}
                  disabled={limitReached}
                  onChange={() => toggleFbPage(acc, page)}
                />
              ))}
            </AccountSubcard>
          ))}
        </PlatformCard>

        {/* Instagram */}
        {/* <PlatformCard title="Instagram" onAdd={openInstaLogin}>
          {instaAccounts.length === 0 && (
            <div className="sp-subcard sp-empty">No Instagram accounts connected.</div>
          )}
          {instaAccounts.map((acc, i) => (
            <AccountSubcard key={acc._id || i} email={acc.name || acc.email} onLogout={() => logout(acc)}>
              <PageRow
                icon={instagramIcon}
                name={acc.name || 'Instagram'}
                checked={!!acc.selected}
                disabled={limitReached}
                onChange={() => toggleCustomPage(acc)}
              />
            </AccountSubcard>
          ))}
        </PlatformCard> */}

        {/* Custom RTMP */}
        <PlatformCard title="Custom RTMP" onAdd={() => setCustomModal(true)}>
          {customAccounts.length === 0 && (
            <div className="sp-subcard sp-empty">No custom RTMP destinations configured.</div>
          )}
          {customAccounts.map((acc, i) => (
            <AccountSubcard key={acc._id || i} email={acc.platformType || 'Custom'} onLogout={() => logout(acc)}>
              <PageRow
                icon={rocketIcon}
                name={acc.name}
                checked={!!acc.selected}
                disabled={limitReached}
                onChange={() => toggleCustomPage(acc)}
              />
            </AccountSubcard>
          ))}
        </PlatformCard>

      </div>{/* end sp-grid */}

      {/* ── Invite section ── */}
      <section className="sp-invite">
        <h3>📣 Convide seus amigos para fazer lives</h3>
        <p>Envie convites por email para que eles possam transmitir usando suas páginas.</p>
        <div className="sp-invite-form">
          <input
            type="email"
            placeholder="Digite o email do convidado"
            value={inviteEmail}
            onChange={e => setInviteEmail(e.target.value)}
          />
          <button className="sp-btn" onClick={sendInvite}>Enviar convite</button>
        </div>

        <div className="sp-grid">
          <div className="sp-card">
            <h3>Facebook — Convidados</h3>
            <div className="sp-subcard sp-empty">Nenhum convidado aceitou ainda</div>
          </div>
          <div className="sp-card">
            <h3>YouTube — Convidados</h3>
            <div className="sp-subcard sp-empty">Nenhum convidado aceitou ainda</div>
          </div>
        </div>
      </section>

      {/* Limit toast */}
      <div className={`sp-toast${limitToast ? ' show' : ''}`}>
        🚫 Você atingiu o limite do seu plano
      </div>

      {/* ── Custom RTMP Modal ── */}
      {customModal && (
        <div className="rs-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setCustomModal(false); }}>
          <div className="rs-modal-box" style={{ width: 460 }}>
            <div className="rs-modal-header">
              <h3>Add Custom RTMP</h3>
              <button className="rs-modal-close" onClick={() => setCustomModal(false)}>✕</button>
            </div>
            <form onSubmit={handleCustomSubmit}>
              <div className="rs-form-group">
                <label className="rs-label">Platform type</label>
                <select className="rs-input" value={customSite} onChange={e => setCustomSite(e.target.value)}>
                  {CUSTOM_SITES.map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Channel name</label>
                <input className="rs-input" value={customName} onChange={e => setCustomName(e.target.value)} placeholder="My Channel" required />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">RTMP URL</label>
                <input className="rs-input" value={customRtmp} onChange={e => setCustomRtmp(e.target.value)} placeholder="rtmp://live.example.com/app" required />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Stream Key</label>
                <input className="rs-input" value={customKey} onChange={e => setCustomKey(e.target.value)} placeholder="stream-key" required />
              </div>
              {customSite === 'Instagram' && (
                <div className="rs-form-group">
                  <label className="rs-label">Orientation</label>
                  <select className="rs-input" value={broadcastType} onChange={e => setBroadcastType(e.target.value)}>
                    <option value="normal">Normal (vertical)</option>
                    <option value="paisagem">Landscape (horizontal)</option>
                    <option value="square">Square</option>
                  </select>
                </div>
              )}
              <div className="rs-form-group">
                <label className="rs-label">Username (optional)</label>
                <input className="rs-input" value={customUser} onChange={e => setCustomUser(e.target.value)} placeholder="login" />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Password (optional)</label>
                <input className="rs-input" type="password" value={customPass} onChange={e => setCustomPass(e.target.value)} />
              </div>
              {hintForSite[customSite] && (
                <p className="sp-hint">
                  Get credentials at&nbsp;
                  <a href={hintForSite[customSite].href} target="_blank" rel="noreferrer">
                    {hintForSite[customSite].label}
                  </a>
                </p>
              )}
              <div className="rs-modal-actions">
                <button type="button" className="rs-btn" onClick={() => setCustomModal(false)}>Cancel</button>
                <button type="submit" className="rs-btn">Add</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/SocialPlatform/SocialPage.js